{
  "to_save": "Save to Library",
  "to_remove": "Click to remove from your Library.",
  "pending": "This schedule will appear in your Library.",
  "saved": "Plan saved",
  "save_plan": "Save this plan"
}
